export default __webpack_public_path__ + "static/media/software-icon.5eea7451.png";